module.exports = { "default": require("core-js/library/fn/number/is-safe-integer"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ../~/_babel-runtime@6.26.0@babel-runtime/core-js/number/is-safe-integer.js
// module id = 943
// module chunks = 0